import React from "react";
import './exam-prep-report.scss';
import Dropdown from '../common/dropdown-v2/dropdown';
import SchoolApi from "../../apis/school";
import DropdownV4 from "../common/dropdown-v4/dropdown";
import Loading from "../common/loading/loading";
import { getImageSource } from "../../utility/image-source";
import { Constants, ImageConstants } from "../../constants/constants";

class ExamPrepReport extends React.Component {

    state = {
        boardsDropdownItems: [],
        classDropdownItems: [],
        subjectsDropdownItems: [],
        selectedBoard: '',
        selectedClass: [],
        selectedSubject: '',
        isCreate: false,
        reloadDropdown: false,
        reloadSubjectDropdown: false,
        isLoading: false
    }

    componentDidMount() {
        this.getClasses();
        this.getSubjectsList();
    }

    getClasses(payload = {}) {
        this.setState({ isLoading: true });

        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                let classes = [], boards = [];
                this.setState({ isLoading: false });

                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    });
                }
                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    });
                }

                if (boards.length > 1) {
                    this.setState({ boardsDropdownItems: boards });
                } else {
                    this.setState({ selectedBoard: school?.boards[0]?.name });
                }

                this.setState({ classDropdownItems: classes, reloadDropdown: true }, () => {
                    this.setState({ reloadDropdown: false });
                });
            })
            .catch(err => {
                this.setState({ isLoading: false });
            });
    }

    getSubjectsList() {
        this.setState({ isLoading: true });

        SchoolApi.getSubjectsList({})
            .then(res => {
                this.setState({ subjectsDropdownItems: res.subjects, isLoading: false });
            })
            .catch(err => {
                this.setState({ isLoading: false });
            });
    }

    onSelectDropDown = (option, key) => {
        this.setState({ [key]: option?.value }, () => {
            if (key === "selectedBoard" || key === "selectedSubject") {
                this.clearFiltersForClass();
            }
        });
    }

    clearFiltersForClass = () => {
        this.setState({ selectedClass: [], isCreate: false, reloadDropdown: true }, () => {
            this.setState({ reloadDropdown: false });
        });
    }

    onSelectClass = (options) => {
        let values = options.map(option => option?.value);
        this.setState({ selectedClass: values });
    }

    isFormValid() {
        const { selectedClass, selectedSubject } = this.state;
        return selectedClass.length > 0 && selectedSubject;
    }

    buildPayload(format) {
        const { selectedBoard, selectedClass, selectedSubject } = this.state;
        let payload = {
            format,
            subjectId: selectedSubject
        };
        if (selectedBoard) payload.board = selectedBoard;
        if (selectedClass.length > 0) payload.class = selectedClass.join(',');
        return payload;
    }

    downloadExamPrepReport(format) {
        if (!this.isFormValid()) {
            this.setState({ isCreate: true });
            return;
        }

        this.setState({ isLoading: true });

        SchoolApi.getExamPrepReport(this.buildPayload(format))
            .then(res => {
                this.setState({ isLoading: false });

                if (format === 'pdf') {
                    // PDF returns a JSON with a pdfLink
                    if (res && res.pdfLink) {
                        this.triggerDownload(res.pdfLink, 'exam_prep_report.pdf');
                    } else {
                        alert("PDF generated but no download link was found.");
                    }
                } else {
                    // Excel returns a blob — handled by the HTTP client via responseType: 'blob'
                    const url = window.URL.createObjectURL(new Blob([res]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'exam_prep_report.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                }
            })
            .catch(err => {
                console.error(err);
                this.setState({ isLoading: false });
                alert("Error while generating the report. Please try again later.");
            });
    }

    triggerDownload(url, filename) {
        if (window.electron?.ipcRenderer) {
            window.electron.ipcRenderer.send('download-pdf', { payload: { fileURL: url } });
            return;
        }
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    clearFilter() {
        this.setState({
            selectedBoard: '',
            selectedClass: [],
            selectedSubject: '',
            isCreate: false,
            reloadDropdown: true,
            reloadSubjectDropdown: true
        }, () => {
            this.setState({ reloadDropdown: false, reloadSubjectDropdown: false });
            this.getClasses();
        });
    }

    onClickBack() {
        return window.location.hash = '#/school/dashboard';
    }

    render() {
        const { isLoading, boardsDropdownItems, selectedBoard, subjectsDropdownItems,
            selectedSubject, classDropdownItems, selectedClass, isCreate,
            reloadDropdown, reloadSubjectDropdown } = this.state;

        return (
            <div className="exam-prep-report">
                {isLoading && <Loading />}
                {this.props.showBackButton || Constants.ELECTRON_BUILD
                    ? <img className='report-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={this.onClickBack} />
                    : ''}

                <div>
                    <div className="title">Exam Prep Report</div>
                </div>

                <div className="row student-leaderboard-class-filter mr-4">

                    {/* Board Dropdown (only when multiple boards exist) */}
                    {boardsDropdownItems.length > 1 &&
                        <div className="col-lg-2 col-md-6 col-sm-12 pt-4">
                            <div className="filter-input-label">
                                Board
                            </div>
                            <div className={isCreate && !selectedBoard ? 'error-border' : ''}>
                                <Dropdown
                                    placeholder='Select a board'
                                    options={boardsDropdownItems}
                                    onSelect={(option) => this.onSelectDropDown(option, "selectedBoard")}
                                    text={"title"}
                                    value={selectedBoard}
                                />
                            </div>
                        </div>
                    }

                    {/* Subject Dropdown */}
                    <div className="col-lg-2 col-md-6 col-sm-12 pt-4">
                        <div className="filter-input-label">
                            Subject<span className='text-danger'>*</span>
                        </div>
                        <div className={isCreate && !selectedSubject ? 'error-border' : ''}>
                            {!reloadSubjectDropdown &&
                                <Dropdown
                                    placeholder='Select a subject'
                                    options={subjectsDropdownItems}
                                    onSelect={(option) => this.onSelectDropDown(option, "selectedSubject")}
                                    text={"title"}
                                    value={selectedSubject}
                                />
                            }
                        </div>
                        {isCreate && !selectedSubject
                            ? <div className='error-text text-danger'>Please Select a subject</div>
                            : ''}
                    </div>

                    {/* Class Multi-Select Dropdown */}
                    <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                        <div className="filter-input-label">
                            Class<span className='text-danger'>*</span>
                        </div>
                        <div className={isCreate && !selectedClass.length ? 'error-border' : ''}>
                            {!reloadDropdown &&
                                <DropdownV4
                                    key="class-multi"
                                    placeholder='Select a Class'
                                    options={classDropdownItems}
                                    onSelect={(option) => this.onSelectClass(option)}
                                    text={"title"}
                                    multiSelect={true}
                                    value={selectedClass}
                                />
                            }
                        </div>
                        {isCreate && !selectedClass.length
                            ? <div className='error-text text-danger'>Please Select a Class</div>
                            : ''}
                    </div>

                    {/* Action Buttons */}
                    <div className="col-lg-4 col-md-6 col-sm-12 pt-4">
                        <div className="filter-input-label">&nbsp;</div>
                        <div className="d-flex align-items-center flex-wrap" style={{ gap: '0.5rem' }}>
                            <button
                                id="exam-prep-report-excel-btn"
                                className="cw-button"
                                onClick={() => this.downloadExamPrepReport('excel')}
                                title="Download Excel"
                            >
                                Excel
                            </button>
                            <button
                                id="exam-prep-report-pdf-btn"
                                className="cw-button pdf-btn"
                                onClick={() => this.downloadExamPrepReport('pdf')}
                                title="Download PDF"
                            >
                                PDF
                            </button>
                            <button
                                id="exam-prep-report-clear-btn"
                                className="cw-button clear-btn"
                                onClick={() => this.clearFilter()}
                            >
                                CLEAR
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

export default ExamPrepReport;
